<template lang="html">
  <div>
    <section>
      <v-parallax
        class="si-hero-parallax"
        dark
        :height="200"
        :src="require('@/assets/background_2.svg')"
      >
        <v-container
          grid-list-lg
          fill-height
          fluid
          :style="`background-color: rgb(0 0 0 / 20%); background:linear-gradient(to ${
            $vuetify.breakpoint.xsOnly ? 'top' : 'right'
          }, rgb(0 0 0 / 50%) 30%, rgb(0 0 0 / 0%)`"
        >
          <v-layout
            justify-center
            align-center
            fill-height
          >
            <v-flex
              xs12
              md10
              lg8
              xl7
              mx-auto
            >
              <v-layout
                wrap
                align-center
              >
                <v-flex
                  xs12
                  class="white--text "
                >
                  <div class="text-h3 text-sm-h2 font-weight-light text-center text-md-left">
                    Contact Us
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-parallax>
    </section>

    <v-container
      grid-list-sm
      my-8
      fluid
    >
      <v-layout wrap>
        <v-flex v-bind="_pageLayout">
          <v-form ref="form">
            <v-layout wrap>
              <v-flex
                xs12
                md5
                mb-4
                pr-6
                class=""
              >
                <div class="text-h6 pb-4">
                  Here to help.
                </div>
                <div>
                  Whether you need help with your calculation, would like to discuss bespoke work, or just want to say hi - we would love to hear from you.
                </div>
                <div class="text-h6 pb-4 mt-6">
                  Commonwealth Superannuation Corporation (CSC)
                </div>
                <div>
                  Please note we are private superannuation experts and valuers and provide a range of factual information and calculations. 
                  If you are looking for manage or obtain specific information about your Commonwealth or Defence Force superannuation fund, please contact the trustee
                  <a
                    href="https://www.csc.gov.au/Members/Contact-us"
                    target="_blank"
                  >Commonwealth Superannuation Corporation</a>
                </div>
              </v-flex>

              <v-flex
              
                xs12
                md7
                md10
                mx-auto
              >
                <v-expand-transition>
                  <v-layout
                    v-if="!submitted"
                    wrap
                  >
                    <v-flex xs6>
                      <SiInputText
                        v-model="contact.firstName"
                        label="First Name"
                        required
                        filled
                      />
                    </v-flex>
                    <v-flex xs6>
                      <SiInputText
                        v-model="contact.lastName"
                        label="Last Name"
                        required
                        filled
                      />
                    </v-flex>
                    <v-flex xs12>
                      <SiInputText
                        v-model="contact.email"
                        label="Email"
                        required
                        filled
                        :rules="[_ruleEmail()]"
                      />
                    </v-flex>
                    <v-flex xs12>
                      <SiInputText
                        v-model="contact.subject"
                        label="Subject"
                        required
                        filled
                      />
                    </v-flex>
                    <v-flex xs12>
                      <SiInputTextarea
                        v-model="contact.message"
                        label="Message"
                        required
                        filled
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      text-right
                    >
                      <v-btn
                        color="primary"
                        :loading="loading"
                        large
                        @click="submitContact"
                      >
                        Submit
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-expand-transition>
                <v-expand-transition>
                  <v-alert
                    v-if="submitted"
                    color="info"
                    outlined
                  >
                    <div class="title">
                      Thank you
                    </div>
                    <div class="">
                      Thank you for contacting Super Info. We'll be in touch soon.
                    </div>
                    <v-btn
                      depressed
                      color="info"
                      class="mt-4"
                      to="/"
                    >
                      Take me home
                    </v-btn>
                  </v-alert>
                </v-expand-transition>
              </v-flex>
            </v-layout>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { rtdb } from '@/plugins/firebase'
import validations from '@/mixins/validations'
import clientPath from '@/plugins/client-path'
import moment from 'moment'

export default {
  mixins: [ validations ],
  data () {
    return {
      submitted: false,
      loading: false,
      contact: {}
    }
  },
  computed: {
    ...mapGetters(['_pageLayout'])
  },
  mounted () {
    clientPath.track(`open_contact`)
  },
  methods: {
    submitContact () {
      if (!this.$refs.form.validate()) return
      this.loading = true
      rtdb.ref('webForms/contact').push(Object.assign(this.contact, { timestamp: new Date().toISOString(), time: moment().format('HH:mm DD-MMM-YYYY') }))
        .then(() => {
          this.submitted = true
          this.loading = false
        })
      clientPath.identify(this.contact.email, `${this.contact.firstName} ${this.contact.lastName}`)
      clientPath.track(`submit_contact`)

    }
  }
}
</script>

<style lang="css" scoped>

</style>
